function testWebP() {
	return new Promise( ( res ) => {
		const webP = new Image();
		webP.src =
			'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
		webP.onload = webP.onerror = function () {
			res( webP.height === 2 );
		};
	} );
}

function addWebPBodyClass( support ) {
	if ( support === false ) {
		if ( document.body.classList ) {
			document.body.classList.add( 'no-webp' );
		} else {
			document.body.className += ' no-webp';
		}
	}
}

testWebP().then( ( support ) => addWebPBodyClass( support ) );
